import type { ILink } from '../_hooks/useHeaderLinks'

const normalize = (path: string) => path.replace(/^\//, '').split(/[?#]/)[0]

/** Same prefix / exact rules as `useActiveLink`, with optional exact-only hub links (`exactActive`). */
function pathMatchesLink(
	pathNorm: string,
	linkTo: string,
	exactOnly: boolean,
	excludeNextSegments?: string[]
): boolean {
	const linkPathNorm = normalize(linkTo)
	if (!pathNorm) return linkPathNorm === '' || linkTo === '/'
	if (!linkPathNorm) return pathNorm === ''
	if (exactOnly) return pathNorm === linkPathNorm
	if (pathNorm === linkPathNorm) return true
	if (!pathNorm.startsWith(`${linkPathNorm}/`)) return false
	if (excludeNextSegments?.length) {
		const rest = pathNorm.slice(linkPathNorm.length + 1).split('/')[0]
		if (rest && excludeNextSegments.includes(rest)) return false
	}
	return true
}

/**
 * True if this nav node should show the active state: any descendant leaf matches the URL,
 * or (for a leaf) the path matches this link’s `to` using prefix rules unless `exactActive`.
 */
export function matchesHeaderNavSubtreeActive(pathWithoutLocale: string, link: ILink): boolean {
	const pathNorm = normalize(pathWithoutLocale)
	if (link.children?.length) {
		return link.children.some(child => matchesHeaderNavSubtreeActive(pathWithoutLocale, child))
	}
	return pathMatchesLink(
		pathNorm,
		link.to,
		link.exactActive === true,
		link.activeExcludeNextSegments
	)
}
